import ClipboardButton from '~/javascripts/behaviors/ClipboardButton';
import CopyLinkIcon from '~/images/icons/copy-link-icon-bg-white.png';
import EmailIcon from '~/images/icons/email-share-icon.png';
import FacebookIcon from '~/images/icons/facebook-share-icon.png';
import TwitterIcon from '~/images/icons/twitter-x-icon.png';
import { useCallback } from 'react';

const ShareIcons = ({ shareUrl, defaultSocialShareContent }) => {
  const copyLink = useCallback((node) => {
    if (node !== null) {
      ClipboardButton($(node));
    }
  }, []);

  const twitterDefaultMessage = defaultSocialShareContent.twitter_share_message;
  const emailDefaultSubject = defaultSocialShareContent.email_share_subject;
  const emailDefaultBody = defaultSocialShareContent.email_share_body;
  const facebookDefaultMessage =
    defaultSocialShareContent.facebook_share_message;

  return (
    <div className='share-icons flex flex-row justify-center pb-3'>
      <div
        className='copy-link px-1 md-px-2'
        data-behavior='ClipboardButton'
        ref={copyLink}
      >
        <a className='btn no-underline' data-clipboard-text={shareUrl}>
          <img height='60px' src={CopyLinkIcon} width='60px' />
          <p className='text-eyebrow-cw-black mt-1'>Copy link</p>
        </a>
      </div>
      <div className='email-campaign px-1 md-px-2'>
        <a
          className='open-email-share no-underline'
          href={`mailto:?to=&body=${emailDefaultBody}&subject=${emailDefaultSubject}`}
        >
          <img height='60px' src={EmailIcon} width='60px' />
          <p className='text-eyebrow-cw-black mt-1'>Email</p>
        </a>
      </div>
      <div className='twitter-share px-1 md-px-2'>
        <a
          className='open-twitter-share no-underline'
          data-behavior='OpenShareDialog'
          href={`https://twitter.com/intent/tweet?text=${twitterDefaultMessage}`}
        >
          <div
            className='bg-cw-black rounded-full flex items-center justify-center'
            style={{ width: `${60}px`, height: `${60}px` }}
          >
            <img height='30px' src={TwitterIcon} width='30px' />
          </div>
          <p className='text-eyebrow-cw-black mt-1'> Post</p>
        </a>
      </div>
      <div className='facebook-share px-1 md-px-2'>
        <a
          className='open-facebook-share no-underline'
          data-behavior='OpenShareDialog'
          href={`https://www.facebook.com/sharer/sharer.php?u=${facebookDefaultMessage}`}
        >
          <img height='60px' src={FacebookIcon} width='60px' />
          <p className='text-eyebrow-cw-black mt-1'>Share</p>
        </a>
      </div>
    </div>
  );
};

export default ShareIcons;
